import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';
import Hero from './components/Hero';
import TrustStrip from './components/TrustStrip';
import CategoryGrid from './components/CategoryGrid';
import SplitCTA from './components/SplitCTA';
import ComparisonTable from './components/ComparisonTable';
import ArticlePreview from './components/ArticlePreview';
import Testimonial from './components/Testimonial';
import AboutIntro from './components/AboutIntro';

export default function Home() {
  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "CSSSpreadsheet",
    "url": "https://cssspreadsheet.ink",
    "description": "Best CSSBuy spreadsheet and proxy shopping lists updated weekly. Compare trusted sellers across CSSBuy, Kakobuy, Superbuy, and Oopbuy.",
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://kaspreadsheet.com/search-{search_term}/name/Shoes.html"
      },
      "query-input": "required name=search_term"
    }
  };

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "CSSSpreadsheet",
    "url": "https://cssspreadsheet.ink",
    "description": "The most updated CSSBuy spreadsheet, Kakobuy spreadsheet, Superbuy spreadsheet, and Oopbuy spreadsheet lists.",
    "sameAs": [
      "https://kaspreadsheet.com"
    ]
  };

  return (
    <>
      <JsonLd data={websiteSchema} />
      <JsonLd data={organizationSchema} />
      <Navbar />
      <main>
        <Hero />
        <TrustStrip />
        <CategoryGrid />
        <SplitCTA />
        <ComparisonTable />
        <ArticlePreview />
        <Testimonial />
        <AboutIntro />
      </main>
      <Footer />
    </>
  );
}